const PIXEL_ID = '1362843239191832'

let initialized = false

export function initPixel() {
  if (initialized) return
  if (typeof window === 'undefined') return

  // Inject Facebook's official pixel snippet as a raw script
  const script = document.createElement('script')
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${PIXEL_ID}');
  `
  document.head.appendChild(script)

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  initialized = true
}

export function trackPageView() {
  initPixel()
  // Small delay to ensure fbq is ready from the injected script
  setTimeout(() => {
    if (typeof (window as any).fbq === 'function') {
      ;(window as any).fbq('track', 'PageView')
    }
  }, 100)
}

export function trackAddToCart() {
  if (typeof (window as any).fbq === 'function') {
    ;(window as any).fbq('track', 'AddToCart')
  }
}
